var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.81 3.985h2.191V.169C11.623.117 10.323 0 8.809 0 5.65 0 3.486 1.987 3.486 5.639V9H0v4.266h3.486V24H7.76V13.267h3.345l.531-4.266H7.759V6.062c.001-1.233.333-2.077 2.051-2.077z",
    transform: "translate(-96.000000, -1039.000000) translate(96.000000, 927.000000) translate(0.000000, 112.000000) translate(0.000000, 0.000000) translate(9.995610, 4.000000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAlt);
export default __webpack_public_path__ + "static/media/facebookAlt.eac5f537.svg";
export { ForwardRef as ReactComponent };